<form [formGroup]="reviewCbsaForm" (ngSubmit)="handleSubmit()">
  <div class="modal-body">
    <div>
      You can now choose
      <span class="font-semibold">any ZIP, County, or Metro in the U.S.</span>
      🎉
    </div>

    <ul>
      <span class="font-medium">Update your markets today to:</span>
      <li>✨ See only the deals that matter</li>
      <li>🚀 Get alerts the moment properties hit your areas</li>
      <li>🎯 Keep your experience personalized</li>
    </ul>

    <div>
      It takes less than a minute—and makes your deal hunt way easier. Type as
      many ZIP, County, or Metros below.
    </div>
  </div>

  <div class="mb-6">
    <app-account-setup-markets
      [disabled]="saving"
      [defaultSelected]="reviewCbsaForm.get('cbsaPreferences')?.value"
      [manageProfile]="false"
      (selectedChange)="handleCbsaPreferences($event)"
      [error]="reviewCbsaForm.get('cbsaPreferences')?.value.length === 0"
    ></app-account-setup-markets>
  </div>

  <div class="fixed-footer">
    <div class="flex-1">
      <app-shared-button [loading]="saving" [disabled]="reviewCbsaForm.invalid">
        Complete
      </app-shared-button>
    </div>

    <div class="mt-2">
      Logged in as <span class="font-semibold">{{ userName }}</span
      >. Not you?
      <a routerLink="/logout"> Sign in with a different account </a>
    </div>
  </div>
</form>
